export const affiliateProgramSetupArticle = {
  title: 'Affiliate Marketing Engine: Program Setup',
  slug: 'affiliate-marketing-program-setup',
  content: `Affiliate Marketing Engine: Program Setup

You must create a program before enabling advanced tabs.

1) Create a program
- Click “Create Program” when prompted.
- Fill commission rate, payment terms, and cookie duration.

2) Configure plans & tiers
- Use Plans and Tiers to define payout structures.

3) Enable approvals & attribution
- Approvals, attribution, and webhooks activate once a program exists.
`,
};
